import styled, { contentPadding, rem, spacingBase } from 'theme';

export const PasswordChecklist = styled.div`
  background-color: var(--ref-color-gray-10);
  ${contentPadding()}
`;

export const Title = styled.div`
  font-weight: var(--ref-font-weight-600);
  margin-bottom: ${() => spacingBase};
`;

export const Check = styled.div<{ check: boolean }>`
  color: ${(p) => (p.check ? 'var(--sys-color-success)' : 'var(--ref-color-gray-100)')};
  display: flex;
  align-items: center;

  svg {
    width: ${rem(20)};
    height: ${rem(20)};
    display: ${(p) => (p.check ? 'initial' : 'none')};
    fill: var(--sys-color-success);
    margin-left: ${() => spacingBase};
  }
`;
